module.exports = __webpack_public_path__ + "dc7ed50040ce31979d98445b7d17bdc2.MP3";